'use client';

import {motion} from 'motion/react';
import {ReactNode} from 'react';

import styles from './accordion.module.scss';
import stylesMobile from './accordion-tab-mobile.module.scss';

interface AccordionTabProps {
    title: string;
    expanded: boolean;
    onClick: () => void;
    children: ReactNode;
}

export function AccordionTabMobile({title, expanded, onClick, children}: AccordionTabProps) {
    return (
        <div className={`${styles.tab} ${expanded ? styles.expanded : ''}`} onClick={onClick}>
            <div className={styles.tabContent}>
                <div className={`${styles.tabHeader} ${stylesMobile.tabHeader}`}>
                    <h3 className={`${styles.title} ${stylesMobile.title}`}>
                        <span className={styles.titleSpan}>{title}</span>
                    </h3>

                    {!expanded && (
                        <button className={`${styles.tabHeaderIcon} ${stylesMobile.tabHeaderIcon}`}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M9.96484 0.929688V19.9997"
                                    stroke="#1A1A1A"
                                    strokeWidth="1.85311"
                                />
                                <path
                                    d="M19.4961 10.4653L0.426088 10.4653"
                                    stroke="#1A1A1A"
                                    strokeWidth="1.85311"
                                />
                            </svg>
                        </button>
                    )}
                </div>

                <motion.section
                    className={styles.content}
                    key={`content`}
                    initial="collapsed"
                    animate={expanded ? 'open' : 'collapsed'}
                    exit="collapsed"
                    variants={{
                        open: {opacity: 1, height: 'auto'},
                        collapsed: {opacity: 0, height: 0},
                    }}
                    transition={{duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98]}}
                >
                    <span className={styles.contentText}>{children}</span>
                </motion.section>
            </div>
        </div>
    );
}
